export default "__VITE_ASSET__fd297b0b__"